<template>
   <div class="card maxCaptl">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col violet">
              <h3><i class="fas fa-dollar-sign"></i>Set Max. Capital</h3>
            </div>
            <div class="text-right">
              <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i>  Set/Trader</a>
            </div>
        </div>
      </div>
      <!-- <small>Current Max. Capital <b>$ {{new Intl.NumberFormat('en-US').format(currentMaxAmount)}}</b></small> -->
      <div class="input-group input-d mb-3">
        <i class="fas fa-dollar-sign"></i>
          <currency-input
            v-model="maxCapital"
            class="form-control"
          />
         <!-- <input type="text"  class="form-control" placeholder="Max: Capital" v-model="maxCapital"> -->
        <div class="input-group-append">
            <button :disabled="maxCapital == 0" @click="setMaximumCapital()" type="button">
              <i v-if="!loading" class="fas fa-check" v-bind:class="maxCapital == 0 ? 'fa-disabled' : ''"></i>
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
            </button>
        </div>
      </div>
  </div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";
export default {
  name: "setmaxcapital",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.maxCapital = this.bidSettings.maxCapital;
        this.currentMaxAmount = this.bidSettings.maxCapital;
      },
      deep: true
    }
  },
  data() {
    return {
      maxCapital : 0,
      currentMaxAmount : 0,
      loading : false

    };
  },
  methods: {
    getMaximumCapital(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/outstandingbid",
            auth
        )
        .then(result => {
          console.log(result);
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    setMaximumCapital(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/organization/bid-settings",
          {
            maxCapital: this.maxCapital,
            orgType : "BID"
          },
          auth
        )
        .then(response => {
          console.log(response);
          this.loading = false;
          this.currentMaxAmount = this.maxCapital;
          this.$alert(this.appMessages.maxCapitalUpdated);

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    navigateListPage(){
      window.location.href = "/bidside/admin-setqtycapital";
    }
  },

  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        //this.getMaximumCapital();
      }
    }); 
  }
};
</script>